import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const EditSuppressionRule = lazy(() =>
  import("@scenes/SuppressionLists/components/EditSuppressionRule").then((module) => ({
    default: module.EditSuppressionRule,
  }))
);

export const suppressionRuleDetailsNRO: NavigationRoutingObject = {
  Component: EditSuppressionRule,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "audience",
  heading: (t: I18nT<"dashboard-navigation">) => t("suppression-lists-nro-heading", "Suppression Lists"),
  pageNameForTracking: () => "Suppression Rule",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    return featureOn("suppression_rules") && hasPermission("appGroup", { permission: "viewSegments" });
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/suppression_lists/:appGroupId",
};
